import { createInstance } from './axios.api'
/**
 * Service to handle posting accessibility report requests.
 * @param request - The request data to be sent.
 * @returns A promise that resolves when the request is successfully sent.
 */
export const postAccessibilityReport = async (request: string): Promise<void> => {
  const axios = createInstance(process.env.VUE_APP_NOTIFICATION_GATEWAY_URL)

  await axios.post('/notification/accessibility-report', { description: request })
}
